import { useEffect, useState } from 'react';
import { postHeartbeat } from '../../services/heartbeat';
export const useHearbeatService = (endpoint, onAuthenticationFailed) => {
  const [nextCallTimestamp, setNextCallTimestamp] = useState(undefined);
  const [sessionExpiryTimestamp, setSessionExpiryTimestamp] = useState(undefined);
  const [callHeartbeatService, setCallHeartbeatService] = useState(false);
  const [deactivated, setDeactivated] = useState(false);
  useEffect(() => {
    if (callHeartbeatService && endpoint && !deactivated) {
      const callAsync = async () => {
        try {
          const response = await postHeartbeat(endpoint, onAuthenticationFailed);
          setCallHeartbeatService(false);

          if (response && response.nextCallTimestamp) {
            setNextCallTimestamp(new Date(response.nextCallTimestamp));
          }

          if (response && response.sessionExpiryTime) {
            setSessionExpiryTimestamp(new Date(response.sessionExpiryTime));
          }
        } catch (error) {
          setDeactivated(true);
        }
      };

      callAsync();
    }
  }, [callHeartbeatService, endpoint, onAuthenticationFailed, deactivated]);
  return {
    nextCallTimestamp,
    sessionExpiryTimestamp,
    callHeartbeatService,
    setCallHeartbeatService,
    deactivated
  };
};